import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import FitmentTireSizeOptionLine from './components/fitment-tire-size-option-line/fitment-tire-size-option-line';
import {
  assemblyPropType,
  isAssemblyOptionEqual
} from '../../../../fitment-by-vehicle-util';

import './fitment-tire-size-option.scss';

function getTireSizeOptionModifiers(isStaggered, isSelected) {
  const selectedModifier = isSelected
    ? 'fitment-tire-size-option--selected'
    : '';
  const staggeredModifier = isStaggered
    ? 'fitment-tire-size-option--staggered'
    : '';
  return `${selectedModifier} ${staggeredModifier}`;
}

function FitmentTireSizeOption(props) {
  const {
    assembly,
    isNormalizedSize = false,
    isSelected: isSelectedProp,
    onClick,
    selectedAssembly
  } = props;

  const { frontTireDescription, isOE } = assembly || {};

  const isStaggered = Boolean(frontTireDescription);
  const isSelectedOption = isAssemblyOptionEqual(assembly, selectedAssembly);
  const isSelected = isSelectedProp === undefined && isSelectedOption;
  const isSelectedOE = isSelectedOption && isOE;

  const onClickWithAssembly = useCallback(() => {
    onClick(assembly);
  }, [assembly, onClick]);

  function getStyleName() {
    let styleName = 'size-option';

    if (isSelected) {
      styleName += ' size-option--selected';
    } else if (isSelectedOE) {
      styleName += ' size-option--selected-oe';
    }

    if (isStaggered) {
      styleName += ' size-option--staggered';
    }

    return styleName;
  }

  return (
    <button
      aria-checked={isSelected}
      className={`fitment-tire-size-option ${getTireSizeOptionModifiers(
        isStaggered,
        isSelected
      )}`}
      onClick={onClickWithAssembly}
      role="radio"
      styleName={getStyleName()}
    >
      {isStaggered ? (
        <>
          <FitmentTireSizeOptionLine
            assemblyDescription={assembly?.frontTireDescription}
            isNormalizedSize={isNormalizedSize}
            label={isOE ? 'factory front tire' : 'front tire'}
          />
          <hr styleName="staggered-divider" />
          <FitmentTireSizeOptionLine
            assemblyDescription={assembly?.rearTireDescription}
            isNormalizedSize={isNormalizedSize}
            label={isOE ? 'factory rear tire' : 'rear tire'}
          />
        </>
      ) : (
        <FitmentTireSizeOptionLine
          assemblyDescription={assembly?.description}
          isNormalizedSize={isNormalizedSize}
          label={isOE ? 'factory tire size' : ''}
        />
      )}
    </button>
  );
}

FitmentTireSizeOption.propTypes = {
  assembly: assemblyPropType,
  isNormalizedSize: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  selectedAssembly: assemblyPropType
};

export default FitmentTireSizeOption;
